module.exports = __webpack_public_path__ + "static/media/stop-4.fca87ff2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-4.svg
// module id = 1349
// module chunks = 0